import React from "react";
import { SocketContext } from "../context/SocketContext";
import { CaregiverDocumentTypeId, CommCenterTicketId, HRSectionStageId } from "../messages";
import useStableCallback from "./useStableCallback";

interface SocketEvents {
  CommCenterTicketUpdated: { ticketId: CommCenterTicketId };
  CommCenterRedirect:
    | {
        type: "ComplianceItem";
        documentTypeId: CaregiverDocumentTypeId;
      }
    | {
        type: "MyMedflytCompliance";
      };

  CommCenterChatRoomRedirect: {
    type: "ChatRoom";
    ticketId: CommCenterTicketId;
  };
  InstapaySuccess: Record<string, never>;
  OnboardingStageUpdated: {
    id: HRSectionStageId;
  };
}

interface Params<$EventName extends keyof SocketEvents> {
  eventName: $EventName;
  onEvent: (payload: SocketEvents[$EventName]) => void;
}

export function useSocket<$EventName extends keyof SocketEvents>(params: Params<$EventName>) {
  const socketContext = React.useContext(SocketContext);
  const stableCallback = useStableCallback(params.onEvent);

  React.useEffect(() => {
    const listener = (payload: any) => {
      stableCallback(JSON.parse(payload));
    };

    return socketContext.addListener(params.eventName, listener);
  }, [params.eventName, socketContext, stableCallback]);
}
